import { render, staticRenderFns } from "./trecho-info.vue?vue&type=template&id=ab37a3aa"
import script from "./trecho-info.vue?vue&type=script&lang=js"
export * from "./trecho-info.vue?vue&type=script&lang=js"
import style0 from "./trecho-info.vue?vue&type=style&index=0&id=ab37a3aa&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports